import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=efc26758"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports